/**
 * 格式化日期
 * @param date 日期对象或时间戳
 * @param format 格式化模板，默认为 'YYYY-MM-DD'
 * @returns 格式化后的日期字符串
 */
export function formatDate(date: Date | number | string, format = 'YYYY-MM-DD'): string {
  const d = new Date(date);
  
  const year = d.getFullYear().toString();
  const month = (d.getMonth() + 1).toString().padStart(2, '0');
  const day = d.getDate().toString().padStart(2, '0');
  const hours = d.getHours().toString().padStart(2, '0');
  const minutes = d.getMinutes().toString().padStart(2, '0');
  const seconds = d.getSeconds().toString().padStart(2, '0');
  
  return format
    .replace('YYYY', year)
    .replace('MM', month)
    .replace('DD', day)
    .replace('HH', hours)
    .replace('mm', minutes)
    .replace('ss', seconds);
}

/**
 * 防抖函数
 * @param fn 需要防抖的函数
 * @param delay 延迟时间，默认为 300ms
 * @returns 防抖后的函数
 */
export function debounce<T extends (...args: Parameters<T>) => ReturnType<T>>(
  fn: T,
  delay = 300
): (...args: Parameters<T>) => void {
  let timer: NodeJS.Timeout | null = null;
  
  return function(...args: Parameters<T>): void {
    if (timer) {
      clearTimeout(timer);
    }
    
    timer = setTimeout(() => {
      fn(...args);
      timer = null;
    }, delay);
  };
}

/**
 * 节流函数
 * @param fn 需要节流的函数
 * @param interval 间隔时间，默认为 300ms
 * @returns 节流后的函数
 */
export function throttle<T extends (...args: Parameters<T>) => ReturnType<T>>(
  fn: T,
  interval = 300
): (...args: Parameters<T>) => void {
  let lastTime = 0;
  
  return function(...args: Parameters<T>): void {
    const now = Date.now();
    
    if (now - lastTime >= interval) {
      fn(...args);
      lastTime = now;
    }
  };
}

/**
 * 获取本地存储的数据
 * @param key 存储的键名
 * @returns 解析后的数据，如果不存在则返回 null
 */
export function getLocalStorage<T>(key: string): T | null {
  const value = localStorage.getItem(key);
  
  if (!value) {
    return null;
  }
  
  try {
    return JSON.parse(value) as T;
  } catch (error) {
    console.error('Error parsing localStorage value:', error);
    return null;
  }
}

/**
 * 设置本地存储的数据
 * @param key 存储的键名
 * @param value 要存储的数据
 */
export function setLocalStorage<T>(key: string, value: T): void {
  try {
    localStorage.setItem(key, JSON.stringify(value));
  } catch (error) {
    console.error('Error setting localStorage value:', error);
  }
}

/**
 * 移除本地存储的数据
 * @param key 存储的键名
 */
export function removeLocalStorage(key: string): void {
  localStorage.removeItem(key);
}

/**
 * 生成唯一ID
 * @returns 唯一ID字符串
 */
export function generateUniqueId(): string {
  return Date.now().toString(36) + Math.random().toString(36).substring(2);
}
// 综合判断并设置HTML标签类
export function detectDevice() {
  const ua = navigator.userAgent;
  const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(ua);
  const isTablet = /(iPad|Tablet|PlayBook|Xoom|Tab)/i.test(ua);
  
  if (isMobile || isTablet) {
    return false
  } else {
    return true
  }
}

export const scrollToId = ({ id }: { id?: string } = {}) => {
  if (!id) return;
  const el = document.getElementById(id);
  if (el) {
    el.scrollIntoView({ behavior: "smooth", block: "start" });
  }
};